import { DataLayerEventType, } from './DataLayer.types';
import FacetClearAllEvent from './Events/FacetClearAllEvent';
import FacetRemovedEvent from './Events/FacetRemovedEvent';
import FacetSelectedEvent from './Events/FacetSelectedEvent';
import MapProductClickEvent from './Events/MapProductClickEvent';
import MapProductImpressionEvent from './Events/MapProductImpressionEvent';
import MapViewEvent from './Events/MapViewEvent';
import MapViewFailEvent from './Events/MapViewFailEvent';
import MatchingAvailabilityEvent from './Events/PDP/MatchingAvailabilityEvent';
import PaginationClickEvent from './Events/PaginationClickEvent';
import PropertyBookEvent from './Events/PDP/PropertyBookEvent';
import PropertyClickEvent from './Events/PropertyClickEvent';
import PropertyPageViewEvent from './Events/PDP/PropertyPageViewEvent';
import SearchNoResultsEvent from './Events/SearchNoResultsEvent';
import SearchPageViewEvent from './Events/SearchPageViewEvent';
import SearchSubmitEvent from './Events/SearchSubmitEvent';
import SearchStartEvent from './Events/SearchStartEvent';
import ServicesSearchSubmitEvent from './Events/PDP/ServicesSearchSubmitEvent';
import SitePageViewEvent from './Events/PDP/SitePageViewEvent';
import SwitchToMapEvent from './Events/SwitchToMapEvent';
import SwitchToListEvent from './Events/SwitchToListEvent';
import ExperienceImpressionEvent from './Events/ExperienceImpressionEvent';
import FacetDrawerOpenEvent from './Events/FacetDrawerOpenEvent';
import FacetDrawerCloseEvent from './Events/FacetDrawerCloseEvent';
// TODO: Rework so eslint can be satisfied
/* eslint-disable consistent-return, default-case */
export default class DataLayerFactory {
    getEvent(type) {
        switch (type) {
            case DataLayerEventType.ExperienceImpression:
                return new ExperienceImpressionEvent();
            case DataLayerEventType.FacetClearAll:
                return new FacetClearAllEvent();
            case DataLayerEventType.FacetRemoved:
                return new FacetRemovedEvent();
            case DataLayerEventType.FacetSelected:
                return new FacetSelectedEvent();
            case DataLayerEventType.MapProductClick:
                return new MapProductClickEvent();
            case DataLayerEventType.MapProductImpression:
                return new MapProductImpressionEvent();
            case DataLayerEventType.MapView:
                return new MapViewEvent();
            case DataLayerEventType.MapViewFail:
                return new MapViewFailEvent();
            case DataLayerEventType.MatchingAvailability:
                return new MatchingAvailabilityEvent();
            case DataLayerEventType.PaginationClick:
                return new PaginationClickEvent();
            case DataLayerEventType.PropertyClick:
                return new PropertyClickEvent();
            case DataLayerEventType.PropertyBook:
                return new PropertyBookEvent();
            case DataLayerEventType.PropertyPageView:
                return new PropertyPageViewEvent();
            case DataLayerEventType.SearchPageView:
                return new SearchPageViewEvent();
            case DataLayerEventType.SearchSubmit:
                return new SearchSubmitEvent();
            case DataLayerEventType.SearchStart:
                return new SearchStartEvent();
            case DataLayerEventType.ServicesSearchSubmit:
                return new ServicesSearchSubmitEvent();
            case DataLayerEventType.SitePageView:
                return new SitePageViewEvent();
            case DataLayerEventType.SearchNoResults:
                return new SearchNoResultsEvent();
            case DataLayerEventType.SwitchToMap:
                return new SwitchToMapEvent();
            case DataLayerEventType.SwitchToList:
                return new SwitchToListEvent();
            case DataLayerEventType.FacetOpen:
                return new FacetDrawerOpenEvent();
            case DataLayerEventType.FacetClose:
                return new FacetDrawerCloseEvent();
        }
    }
}
//# sourceMappingURL=DataLayerFactory.js.map